import { Box, Text, Button } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import get from "lodash/get";
import { deleteAnnouncement } from "../../redux/api_calls/apiCalls";
import IndividualAnnouncementCard from "./IndividualAnnouncementCard";

export default function AllAnnouncements({
  announcements,
  method,
  loadMoreVisible,
}) {
  const dispatch = useDispatch();

  const deleteHandler = (id) => {
    let updatedAnnouncements = announcements.filter(
      (announcement) => announcement.id !== id
    );
    let announcementToRemove = announcements.find(
      (announcement) => announcement.id === id
    );
    dispatch(
      deleteAnnouncement(updatedAnnouncements, id, announcementToRemove)
    );
  };

  return (
    <Box
      width={["90%", "85%", "80%", "80%"]}
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      d={["none", "none", "none", "flex"]}
      mb="1.5rem"
    >
      <Box
        d={["none", "none", "none", "flex"]}
        justifyContent="space-between"
        width="100%"
      >
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          ml="1rem"
          width="30%"
        >
          ANNOUNCEMENTS
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          textAlign="center"
          width="23.5%"
        >
          CLASS
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          textAlign="center"
          width="17%"
        >
          Start Date
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          textAlign="center"
          width="17%"
        >
          End Date
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          textAlign="center"
          width="10%"
        >
          ACTIONS
        </Text>
      </Box>
      {announcements.map((announcement) => {
        console.log(announcement);
        return (
          <IndividualAnnouncementCard
            key={announcement.id}
            id={announcement.id}
            image={announcement.image_url}
            title={announcement.title}
            startingDate={announcement.start_date}
            endingDate={announcement.end_date}
            startingTime={announcement.start_time}
            endingTime={announcement.end_time}
            department={get(announcement, "class_id", "N/A")}
            removeAnnouncement={deleteHandler}
            createdDate={announcement.created_at}
          />
        );
      })}
      {loadMoreVisible && (
        <Button
          color="#00000099"
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="700"
          fontSize={["12px", "14px", "16px", "18px"]}
          border="2px solid rgba(0, 0, 0, 0.1)"
          boxShadow="0px 3px 16px rgba(0, 0, 0, 0.1)"
          borderRadius="xl"
          py={["0.5rem", "0.75rem", "1rem", "1.5rem"]}
          px={["0.75rem", "1rem", "1.5rem", "2rem"]}
          m="2rem"
          bg="#ffffff"
          onClick={method}
        >
          Load More...
        </Button>
      )}
    </Box>
  );
}
